/**
 * Foil-medallion with initials — the always-on hero-zone content of the
 * persona card since Plan #10 (v0.10.0). Originally inlined in
 * ArchetypeCallout (Plan #3); extracted in Plan #9.
 */
export function Medallion({ initials }: { initials: string }) {
  return (
    <div class="absolute inset-0 flex items-center justify-center">
      <div class="relative h-24 w-24">
        <div
          class="absolute inset-0 rounded-full"
          style={{
            background:
              'conic-gradient(from 0deg, var(--color-foil-deep), var(--color-foil), var(--color-foil-bright), var(--color-foil), var(--color-foil-deep))',
          }}
        />
        <div
          class="absolute inset-[3px] rounded-full flex items-center justify-center"
          style={{
            background:
              'radial-gradient(circle at 35% 30%, #1a2538 0%, #0a0e14 70%)',
            boxShadow: 'inset 0 0 20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(251,191,36,0.2)',
          }}
        >
          <span
            class="font-display text-3xl text-text leading-none"
            style={{ textShadow: '0 1px 0 rgba(0,0,0,0.5), 0 0 18px rgba(251,191,36,0.35)' }}
          >{initials}</span>
        </div>
      </div>
    </div>
  );
}
